import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';


@Component({
    selector: 'app-base',
    template: ``
})

export class BaseComponent implements OnInit {
    formGroup: FormGroup;
    toFormGroup: FormGroup;

    // constructor(props?) {
        // this.toFormGroup = this.fb.group({});
    // }
    ngOnInit(): void {

    }



    public cloneFormGroup(formGroup) {
        return Object.assign({}, formGroup);
        // this.formGroup.
        // Object.keys(this.formGroup.controls).forEach((k: any) => {
        //     this.toFormGroup.addControl(k, this.formGroup.controls[k]);
        // });

    }




}
